import AppFormList from "@/controllers/application_form/app-form-list";
import CONFIG from "@/assets/js/config.custom.js";

export default {
  extends: AppFormList,

  data() {
    return {
      urlPrefix: CONFIG.APPLICATION.URL_PREFIX,
      appTypeText: CONFIG.APPLICATION.TYPE_TXT,
    };
  },
}
